import axios, { AxiosError } from "axios";
import { parseCookies } from "nookies";
import { toast } from "react-toastify";

const cookies = parseCookies();

(function () {
  const token = cookies["controlTower.token"];
  if (token) {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${cookies["controlTower.token"]}`;
  } else {
    axios.defaults.headers.common["Authorization"] = "";
  }
})();

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Access-Control-Allow-Origin": `${process.env.REACT_APP_API_URL}`,
  },
});

export const errorTreatment = (error: AxiosError) => {
  if (error.response?.status && error.response.status === 401) {
    toast.error("Necessário estar autenticado!", {
      position: toast.POSITION.TOP_RIGHT,
    });
    window.location.assign(`/login`);
  } else {
    toast.error(error.message, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
};
